export default class BackToTopButton {
  constructor() {
    this.button = document.querySelector("[data-js-button='back-to-top']");
    this.hiddenClass = "js-hidden";
    this.scrollOffset = 100;

    if (this.button) {
      this.button.classList.add(this.hiddenClass);
      this.init();
    }
  }

  init() {
    window.addEventListener("scroll", () => this.toggleVisibility());
    this.button.addEventListener("click", () => this.scrollToTop());
  }

  toggleVisibility() {
    if (window.scrollY > this.scrollOffset) {
      this.button.classList.remove(this.hiddenClass);
      this.button.setAttribute("aria-hidden", "false");
      this.button.setAttribute("tabindex", "0");
    } else {
      this.button.classList.add(this.hiddenClass);
      this.button.setAttribute("aria-hidden", "true");

    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new BackToTopButton();
});